<template>
  <div>
    <div class="cover-table">
      <Table
        border
        style="width: 100%;"
        :loading="loading"
        :columns="tableColumns"
        :data="tableData"
        highlight-row
      >
        <template slot-scope="{ row, index }" slot="action">
          <span class="pointer" @click="handleDeal('projectDetail', row.id)"
            >详情</span
          >
        </template>
      </Table>
      <Page
        class="page"
        :total="totalCount"
        :page-size="pageSize"
        :current="page"
        @on-change="changePage"
        @on-page-size-change="pageSizeChange"
        show-elevator
        show-sizer
        show-total
        transfer
      >
      </Page>
    </div>
  </div>
</template>
<style scoped></style>
<script>
import tableTwoMixin from "@/components/tableTwoMixin";
export default {
  mixins: [tableTwoMixin],
  data() {
    return {
      tableColumns: [
        {
          title: "序号",
          type: "index",
          width: 70,
          fixed: "left",
          align: "center",
        },
        { title: "项目编号", key: "projectId", minWidth: 180, tooltip: true },
        {
          title: "统一社会信用代码",
          key: "corpCode",
          minWidth: 180,
          tooltip: true,
        },
        { title: "企业名称", key: "corpName", minWidth: 180, tooltip: true },
        { title: "参建类型", key: "corpType", minWidth: 140, tooltip: true },
        { title: "进场时间", key: "entryTime", minWidth: 180, tooltip: true },
        {
          title: "退场时间",
          key: "exitTime",
          minWidth: 180,
          tooltip: true,
        },
        {
          title: "发放工资的银行",
          key: "bankInfos",
          minWidth: 140,
          tooltip: true,
        },
        {
          title: "项目经理名称",
          key: "pmName",
          minWidth: 140,
          tooltip: true,
        },
        // { title: '参建班组', key: 'teamName', minWidth: 210, tooltip: true },
        {
          title: "项目经理证件类型",
          key: "pmIDCardType",
          minWidth: 180,
          tooltip: true,
        },
        {
          title: "项目经理证件号码",
          key: "pmIDCardNumber",
          minWidth: 180,
          tooltip: true,
        },
        {
          title: "项目经理电话",
          key: "pmPhone",
          minWidth: 180,
          tooltip: true,
        },
        {
          title: "数据来源",
          key: "projectAreaCode",
          minWidth: 100,
        },
      ],
    };
  },
};
</script>
